{
  "en": {
    "pages": {
      "bookingPayment": {
        "headTitle": "Payment for booking #{bookingId}",
        "pageTitle": "Confirm & make a payment",
        "pageTitlePrepaid": "Add payment information",
        "onlyChargeIfOwnAccepts": "Tip: Hosts often respond quicker to requests that include a payment method.",
        "pageInfo": "Add the credit card information you’d like to use for any payments and deposits required for this rental.",
        "enterPaymentInformation": "Enter payment information",
        "promoCodeLabel": "Have a promo code?",
        "promoCodePlaceholder": "Enter promo code",
        "submitNotice": "By clicking “Confirm & Pay”, I am agreeing to RVezy's terms and conditions, and authorize my credit card on file for future booking charges, including any damage charges and the security deposit required 72hrs before the trip start date.",
        "submitNoticeUninsured": "By clicking “Confirm & Pay”, I am agreeing to RVezy's terms and conditions, authorize my credit card on file for future booking charges, and understand that RVezy does not provide insurance coverage for this trip.",
        "submitNoticePrepaid": "By selecting the button below, I agree to RVezy’s Terms of Service and authorize my credit card on file for future booking changes.",
        "submitNoticeUninsuredPrepaid": "By selecting the button below, I agree to RVezy’s Terms of Service and authorize my credit card on file for future booking changes, and understand that RVezy does not provide insurance coverage for this trip.",
        "confirmAndPay": "Confirm & Pay",
        "submitPaymentInfo": "Submit payment information",
        "requestToBook": "Request to book",
        "requestToBookNotice": "By selecting \"Request to book\" I agree to RVezy’s Terms of Service and authorize my credit card on file for future booking charges.",
        "requestToBookDelayedPayment": "You won’t be charged until the owner accepts.",
        "failedBox": {
          "title": "Payment failed",
          "description": "We were unable to process payment from the credit card on file. Please verify all details are correct or provide alternative payment method."
        },
        "creditMessage": "Your referral credit will be applied upon payment.",
        "unknownError": "An error occurred",
        "validationError": "A validation error occurred. Please check the highlighted fields.",
        "stripeErrors": {
          "bookingOverlapsDates": "The dates requested are no longer available. Please contact {owner} to make sure the dates are not blocked in their calendar."
        },
        "authenticationFailed": "We are unable to authenticate your payment method. Please choose a different payment method and try again.",
        "promoCode": {
          "label": "Promo code",
          "noQualify": "This booking does not qualify for this promotional code",
          "invalid": "Invalid promo code",
          "inactive": "This promotional code is no longer active",
          "maximumUses": "You have already reached the maximum number of uses for this promotional code",
          "promotionLimitTotalQuantity": "This promotion has already reached its maximum number of uses and is no longer available.",
          "wrongCountry": "This promotional code is not available in this country"
        },
        "stripeBadge": "Secure SSL encryption",
        "updatePaymentMethod": "Update payment method",
        "weSaveYourCard": "We must save your credit card to your account in order to proceed with booking.",
        "hostHas48HoursToRespond": "The host will respond within 48 hours.",
        "agreeToTerms": "By completing a booking RVezy, you agree to the RVezy {terms} and {privacy}."
      }
    }
  },
  "fr": {
    "pages": {
      "bookingPayment": {
        "headTitle": "Paiement pour la réservation #{bookingId}",
        "pageTitle": "Confirmer et effectuer un paiement",
        "pageTitlePrepaid": "Ajoutez vos informations de paiement",
        "onlyChargeIfOwnAccepts": "Conseil : les hôtes répondent souvent plus rapidement aux demandes comportant une méthode de paiement.",
        "pageInfo": "Ajoutez l'information de carte de crédit que vous voulez utiliser pour tout paiement et dépôt requis pour cette location.",
        "enterPaymentInformation": "Ajoutez vos informations de paiement",
        "promoCodeLabel": "Avez-vous un code promo?",
        "promoCodePlaceholder": "Saisir le code promotionnel",
        "submitNotice": "En cliquant sur “Confirmer et payer”, j’accepte les modalités de RVezy et j’autorise ma carte de crédit au dossier pour les frais de réservation futurs, y compris les frais de dommages et le dépôt de garantie requis 72 heures avant la date de début de la location.",
        "submitNoticeUninsured": "En cliquant sur \"Confirmer et payer\" j’accepte les termes et conditions de RVezy, j’autorise l’utilisation de ma carte de crédit enregistrée pour les frais de réservation futurs et je comprends que RVezy ne fournit pas de couverture d’assurance pour ce voyage.",
        "submitNoticePrepaid": "En sélectionnant le bouton ci-dessous, j’accepte les conditions de service de RVezy et j’autorise ma carte de crédit enregistrée pour les changements de réservation futurs.",
        "submitNoticeUninsuredPrepaid": "En sélectionnant le bouton ci-dessous, j’accepte les conditions de service de RVezy et j’autorise ma carte de crédit enregistrée pour les changements de réservation futurs, et je comprends que RVezy ne fournit pas de couverture d’assurance pour ce voyage.",
        "confirmAndPay": "Confirmer et payer",
        "submitPaymentInfo": "Soumettez vos informations de paiement",
        "requestToBook": "Demande de réservation",
        "requestToBookNotice": "En sélectionnant \"Demande de réservation\" j’accepte les modalités de RVezy et j’autorise ma carte de crédit pour les futurs frais de réservation.",
        "requestToBookDelayedPayment": "Vous ne serez pas facturé jusqu’à ce que le propriétaire accepte.",
        "failedBox": {
          "title": "Paiement échoué",
          "description": "Nous n’avons pas pu traiter le paiement à partir de la carte de crédit au dossier. Veuillez vérifier que tous les détails sont exacts ou fournir un autre mode de paiement."
        },
        "creditMessage": "Votre crédit sera appliqué dès que vous ferez le paiement.",
        "unknownError": "Une erreur s'est produite.",
        "validationError": "Une erreur de validation s'est produite. Veuillez vérifier les champs soulignés.",
        "stripeErrors": {
          "bookingOverlapsDates": "Les dates demandées ne sont plus disponibles. Veuillez contacter le {owner} pour vous assurer que les dates ne sont pas bloquées dans leur calendrier."
        },
        "authenticationFailed": "Nous ne parvenons pas à authentifier votre moyen de paiement. Veuillez en choisir un autre et réessayer.",
        "promoCode": {
          "label": "Code promotionel",
          "noQualify": "Cette réservation ne se qualifie pas pour le code promotionel.",
          "invalid": "Code promotionel invalide",
          "inactive": "Ce code promotionnel n’est plus actif",
          "maximumUses": "Vous avez déjà atteint le nombre maximum d’utilisations de ce code promotionnel",
          "promotionLimitTotalQuantity": "Cette promotion a déjà atteint son maximum d'utilisations et n'est plus disponible.",
          "wrongCountry": "Ce code promotionnel n’est pas disponible dans ce pays"
        },
        "stripeBadge": "Cryptage SSL sécurisé",
        "updatePaymentMethod": "Mettre à jour le mode de paiement",
        "weSaveYourCard": "Nous devons sauvegarder votre carte de crédit pour pouvoir procéder avec la réservation.",
        "hostHas48HoursToRespond": "L’hôte répondra dans les 48 heures.",
        "agreeToTerms": "En complétant une réservation sur RVezy, vous acceptez les {terms} et {privacy} de RVezy."
      }
    }
  }
}
